/**
 * Locale: English · activated via language toggle.
 */
const en = {
  common: {
    save: "Save",
    saveChanges: "Save changes",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    confirm: "Confirm",
    close: "Close",
    loading: "Loading…",
    saving: "Saving…",
    search: "Search…",
    yes: "Yes",
    no: "No",
    reload: "Reload",
    refresh: "Refresh",
    new: "New",
    actions: "Actions",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    name: "Name",
    email: "Email",
    password: "Password",
    role: "Role",
    logout: "Sign out",
    settings: "Settings",
    notifications: "Notifications",
    backToDashboard: "Back to dashboard",
    error: "Error",
    success: "Done",
    required: "Required",
    optional: "Optional",
  },

  language: {
    label: "Language",
    es: "Spanish",
    en: "English",
    toggleTooltip: "Change language",
  },

  login: {
    welcome: "Welcome",
    subtitle: "Sign in to your account",
    tabLogin: "Sign in",
    tabSignup: "Request access",
    email: "Email",
    emailPlaceholder: "you@valorizasm.com",
    password: "Password",
    passwordPlaceholder: "••••••••",
    submit: "Sign in",
    submitting: "Signing in…",
    invalidCredentials: "Invalid credentials",
    platformName: "Corporate Platforms",
    platformTagline: "Valoriza's commercial cockpit: tender detection, pipeline, offers and committee in one place",
    forgotPassword: "Forgot your password?",
    signupName: "Full name",
    signupSubmit: "Request access",
    signupSuccess: "Request submitted. You'll receive an email once an administrator approves it.",
  },

  forcePasswordChange: {
    title: "Password change required",
    helloUser: "Hello {{name}}. For security reasons, please set your personal password.",
    currentLabel: "Current password (temporary)",
    currentPlaceholder: "Temporary password received",
    newLabel: "New password",
    newPlaceholder: "Choose a strong password",
    repeatLabel: "Repeat new password",
    repeatPlaceholder: "Confirm the password",
    logout: "Sign out",
    submit: "Set password",
    submitting: "Saving…",
    mismatch: "Passwords don't match",
    success: "Password updated. Welcome to the platform.",
    rule: {
      minLen: "At least 8 characters",
      upper: "At least one uppercase letter",
      digit: "At least one number",
      match: "Passwords match",
    },
  },

  layout: {
    appName: "Valoriza",
    appTagline: "Corporate Platforms",
    searchPlaceholder: "Search…",
    administrator: "Administrator",
    sectionManagement: "Management",
    sectionCommercial: "Commercial",
    sectionOperations: "Operations",
    sectionAnalytics: "Analytics",
    // Iter311 · G02 — "five spaces" from the improvements report
    sectionExecution: "Contracts & Execution",
    sectionDirection: "Direction",
    sectionAdmin: "Administration",
    dashboard: "Dashboard",
    miTrabajo: "My work",
    projects: "Projects",
    backlog: "Backlog",
    sprints: "Sprints",
    checklists: "Checklists",
    offers: "IT Offers",
    ofertasComercial: "Tenders",
    tenderIntelligence: "Tender Intelligence",
    mercadoSectorial: "Market Intelligence",
    horas: "Hours Management",
    integrationIt: "IT Integration",
    tender360: "US_BID360",
    licitaciones: "Public Tenders (legacy)",
    oraZaragoza: "Zaragoza Parking",
    budget: "Budget",
    resources: "Resources",
    assignments: "Assignments",
    devops: "Azure DevOps",
    incidenciasCalidad: "Quality Incidents",
    manuals: "Manuals",
    reports: "Reports",
    executive: "Executive Dashboard",
    committee: "Committee",
    weeklySummary: "Weekly Summary",
    resourceReport: "Resource Report",
    aiHistory: "Pando History",
    adjudicaciones: "Awards",
    catalogoServicios: "Service Catalog",
    itPeticiones: "IT Requests",
    demanda: "Demand",
    innovacion: "Innovation",
    pocAi: "Pando PoCs",
    appCatalog: "App Catalog",
    admin: "Administration",
    auditLog: "Audit Log",
    sectionPlatform: "Platform",
    sectionKnowledge: "Knowledge & Innovation",
    sectionFavorites: "Favorites",
    arrive: "ARRIVE Checklists",
  },

  cmdk: {
    placeholder: "Search modules, projects, tenders…",
    empty: "No results",
    searching: "Searching the platform…",
    navigation: "Navigation",
    recents: "Recent",
    actions: "Actions",
    darkMode: "Enable dark mode",
    lightMode: "Enable light mode",
    logout: "Log out",
    projects: "Projects",
    licitaciones: "Tenders",
    offers: "IT Offers",
    vsm: "VSM Contracting",
    checklists: "Checklists",
    horas: "Projects · Hours",
  },

  delegado: {
    headerLabel: "Valoriza · Regional Delegate",
    reload: "Refresh",
    logout: "Sign out",
    kpi: {
      activeOpps: "Active opportunities",
      activeOppsHint: "Pando score ≥ {{min}}",
      urgent: "Urgent",
      urgentHint: "Score ≥ 90",
      next7d: "Next 7 days",
      next7dHint: "Submission deadline approaching",
    },
    filter: {
      label: "Filter:",
      new: "New (unreviewed)",
      reviewed: "Reviewed",
      discarded: "Discarded",
      all: "All",
    },
    empty: {
      title: "No opportunities in this filter",
      hint: "We'll email you as soon as new ones arrive in your zone",
    },
    badge: {
      new: "New",
      reviewed: "Reviewed",
      discarded: "Discarded",
    },
    card: {
      score: "Score",
      pub: "Pub:",
      noDeadline: "No deadline",
      daysLeft: "{{n}} days",
      daysAgo: "Expired ({{n}}d)",
      pliegoOriginal: "Original tender ({{src}})",
      review: "Review / Comment",
      editReview: "Edit review",
      organismFallback: "Unspecified organism",
    },
    modal: {
      title: "Review opportunity",
      estado: "Status",
      reviewedBtn: "✓ Reviewed",
      discardedBtn: "✕ Discarded",
      newBtn: "↺ New",
      comentario: "Internal comment",
      comentarioPlaceholder: "Notes for your personal follow-up (e.g. contact at city hall, risks detected…)",
      saveSuccess: "Marked as {{estado}}",
    },
    toast: {
      loadError: "Error loading data",
      saveError: "Error saving",
    },
    loadingPanel: "Loading your dashboard…",
  },

  greeting: {
    morning: "Good morning",
    afternoon: "Good afternoon",
    evening: "Good evening",
  },

  dashboard: {
    quickActions: "Quick actions",
    pendingApproval: "Pending Approval",
    pendingApprovalSub: "Offers in your inbox",
    budgetExecuted: "Budget Executed",
    approvedOffers: "Approved Offers",
    approvedOffersSub: "this year",
    weightedPipeline: "Weighted Pipeline",
    activeFiles: "{{n}} active tenders",
    pendingOffersTitle: "Offers pending your approval",
    noDate: "No date",
    activeFilesKpi: "Active tenders",
    inPipeline: "in pipeline",
    won: "Won",
    wonSub: "tenders awarded",
    ongoingOffers: "Ongoing offers",
    ongoingOffersSub: "pending validation",
    tcatApps: "IT Apps available",
    tcatAppsSub: "in catalog",
    pipelineTitle: "Tender Pipeline",
    pendingTicTitle: "Pending IT Validation",
    pendingTicSub: "require your review",
    pendingCfoTitle: "Pending CFO",
    pendingCfoSub: "awaiting CFO approval",
    activeProjects: "Active Projects",
    activeProjectsSub: "{{n}} total",
    tcatCatalog: "Apps in Catalog",
    tcatCatalogSub: "IT catalog updated",
    ticValidationQueue: "IT validation queue",
    roles: {
      cfo: "CFO · Valoriza Corporate Platforms",
      offerManager: "Bid Manager · Valoriza Corporate Platforms",
      itValidator: "IT Validation · Valoriza Corporate Platforms",
      admin: "Corporate Platforms · Administrator",
    },
    pipeline: {
      prospecto: "Prospect",
      docs: "Docs",
      aiAnalysis: "Pando Analysis",
      prep: "Bid prep.",
      submitted: "Submitted",
      negotiation: "Negotiation",
    },
    projectState: {
      active: "Active",
      completed: "Completed",
      paused: "Paused",
      blocked: "Blocked",
    },
    budgetCat: {
      licenses: "Licenses",
      external: "External resources",
      internal: "Internal resources",
    },
    budgetVsExecuted: "Budget vs Executed",
  },

  tender: {
    title: "US_BID360",
    subtitle: "Public tender pipeline and external opportunities",
    filters: "Filters",
    refreshSources: "Sync sources",
    search: "Search by title, organism, CPV…",
    source: "Source",
    area: "Area",
    province: "Province",
    status: "Status",
    scoreMin: "Min. score",
    deadline: "Submission deadline",
    organism: "Organism",
    value: "Value",
    publication: "Published",
    score: "Pando Score",
    rationale: "Pando Rationale",
    viewDetails: "View details",
    convertToOffer: "Convert to offer",
    open: "Open tender",
    runAi: "Run Pando analysis",
    aiRunning: "Analyzing…",
    noResults: "No opportunities",
    noResultsHint: "Adjust filters or run a sync",
    showing: "Showing {{n}} of {{total}}",
    cuadroMando: "Dashboard",
    analytics: "Analytics",
    map: "Map",
  },

  offers: {
    title: "IT Offers",
    subtitle: "Offer portfolio with CAPEX/OPEX and IT + CFO validation",
    new: "New offer",
    state: "State",
    validationStatus: "Validation",
    capex: "CAPEX",
    opex: "OPEX",
    total: "Contract total",
    deadline: "Submission",
    requestValidation: "Request IT validation",
    validateTic: "Validate IT",
    requestCfo: "Request CFO approval",
    approveCfo: "Approve CFO",
    desestimate: "Dismiss",
    states: {
      draft: "Draft",
      borrador: "Draft",
      in_review: "In review",
      pending_validation: "Waiting IT",
      pending_cfo: "Waiting CFO",
      pending_cfo_approval: "Waiting CFO",
      approved: "Approved",
      approved_with_conditions: "Approved with conditions",
      rejected: "Rejected",
      desestimada: "Dismissed",
    },
  },

  ofertasComercial: {
    title: "VSM Contracting",
    subtitle: "Commercial pipeline for urban services tenders",
    new: "New offer",
    importExcel: "Import Excel",
    exportExcel: "Export Excel",
    expediente: "File no.",
    cliente: "Client",
    objeto: "Contract object",
    presupuesto: "Budget",
    deadline: "Submission",
    estado: "Tender state",
    aiScore: "Pando Score",
    compliance: "Compliance",
    competitive: "Competitive analysis",
    estadoLicitacion: {
      estudio: "Under study",
      no_estudio: "Not pursued",
      presentada: "Submitted",
      ganada: "Won",
      perdida: "Lost",
      adjudicada: "Awarded",
    },
  },

  compliance: {
    title: "Pando Compliance Check",
    rerun: "Re-run",
    generating: "Generating…",
    analyzing: "Analyzing offer with Pando… (≈10-20 s)",
    verifications: "Checks",
    blockers: "Blockers",
    alerts: "Alerts",
    recommendations: "Recommendations",
    conclusion: "Conclusion",
    generatedBy: "Generated: {{date}} · by {{author}}",
    nivel: {
      ok: "Compliance OK",
      atencion: "Needs attention",
      bloqueante: "Blocker",
    },
    verif: {
      plazos: "Deadlines",
      presupuesto: "Budget & profitability",
      encaje_negocio: "Business area fit",
      plataforma: "Tender platform",
      competencia: "Competitive analysis",
      datos_oferta: "Form completeness",
    },
  },

  manuals: {
    title: "Manuals",
    subtitle: "Official platform documentation",
    download: "Download PDF",
    view: "View online",
    platform: "Platform Manual",
    apiIntegration: "API Integration Manual",
    offers: "Offers Manual",
    tender360: "US_BID360 Manual",
  },

  reports: {
    title: "Pando Reports",
    subtitle: "Executive summaries and analyses generated by Pando",
    weekly: "Weekly summary",
    monthly: "Monthly summary",
    custom: "Custom report",
    generate: "Generate new",
    runAi: "Run Pando",
    download: "Download",
  },

  projects: {
    title: "Projects",
    subtitle: "Active .NET and GIS projects",
    new: "New project",
    name: "Name",
    state: "State",
    owner: "Owner",
    startDate: "Start",
    endDate: "End",
    progress: "Progress",
    states: {
      active: "Active",
      paused: "Paused",
      completed: "Completed",
      blocked: "Blocked",
    },
  },

  backlog: {
    title: "Backlog",
    subtitle: "User stories and pending tasks",
    new: "New story",
    storyPoints: "SP",
    priority: "Priority",
    sprint: "Sprint",
    assignee: "Assignee",
    column: {
      todo: "To do",
      inProgress: "In progress",
      review: "Review",
      done: "Done",
    },
  },

  admin: {
    title: "Administration",
    subtitle: "User management, permissions and system configuration",
    users: {
      title: "Users",
      pending: "Pending approval",
      active: "Active",
      approve: "Approve",
      reject: "Reject",
      changeRole: "Change role",
      resetPassword: "Reset password",
    },
    quotas: {
      title: "OpenAI-compat Quotas",
      monthlyLimit: "Monthly limit (tokens)",
      rpm: "RPM",
      used: "Used",
      newQuota: "New quota",
    },
    sync: {
      title: "Environment Sync",
      downloadDump: "Download JSON dump",
      uploadJson: "Upload & apply JSON",
      applying: "Applying…",
      lastSync: "Last sync",
    },
    delegados: {
      title: "Regional Delegates",
      subtitle: "Geographic-filtered opportunity alerts (view at /delegado)",
      newDelegado: "New delegate",
      editDelegado: "Edit delegate",
      reload: "Reload",
      empty: "No delegates configured yet. Create the first one with \"New delegate\".",
      cols: {
        delegado: "Delegate",
        zone: "Zone",
        aiAreas: "Pando Areas",
        scoreMin: "Min. score",
        status: "Status",
        actions: "Actions",
      },
      form: {
        emailRequired: "Email and name are required",
        zoneRequired: "Select at least one province or region",
        template: "Zone template",
        templateHint: "Choosing a zone autocompletes provinces and regions from the official list.",
        templateCustom: "— Custom (edit manually) —",
        provincias: "Provinces (CSV)",
        comunidades: "Autonomous regions (CSV)",
        aiAreasLabel: "Pando Areas · Valoriza core",
        scoreMinLabel: "Minimum Pando score",
        scoreHint: "Recommended: 75",
        activeLabel: "Active (receives emails)",
        autoCreate: "On save, if the user doesn't exist it will be auto-created with role",
        autoCreatePwd: "initial password",
        autoCreateLogin: "and forced change at first login. The delegate can sign in directly at",
        save: "Create delegate",
        userCreated: "✓ Delegate created · user account also generated (initial pwd: Valoriza2026!)",
        updated: "Delegate updated",
        configured: "Delegate configured (user already existed)",
        deleteConfirm: "Delete delegate configuration for {{email}}?",
        deleted: "Configuration deleted",
      },
    },
  },
  arrive: {
    title: "ARRIVE Checklists",
    subtitle: "Mobility app testing checklists",
    newChecklist: "New checklist",
    importExcel: "Import from Excel (Pando)",
    exportExcel: "Export Excel",
    importResults: "Import results from Excel",
    city: "City",
    checklist: "Checklist",
    category: "Category",
    subcategory: "Subcategory",
    item: "Item",
    result: "Result",
    observations: "Observations",
    date: "Date",
    responsible: "Responsible",
    completion: "Completion",
    items: "items",
    ok: "OK",
    nok: "NOK",
    na: "N/A",
    noResult: "No result",
    noChecklists: "No checklists yet",
    createFirst: "Create the first checklist to get started",
  },
  projectDetail: {
    workItems: "Work Items",
    listView: "List",
    kanbanView: "Board",
    newItem: "New item",
    markComplete: "Mark as complete",
    saveChanges: "Save changes",
    sendToDevops: "Send to DevOps",
    publishToDevops: "Publish in DevOps",
    teamNotes: "Team notes",
    addNote: "Add a note (Ctrl+Enter to save)…",
    title: "Title",
    status: "Status",
    priority: "Priority",
    type: "Type",
    assignedTo: "Assigned to",
    sprint: "Sprint",
    storyPts: "Story Pts",
    estimatedH: "Est. (h)",
    completedH: "Completed (h)",
    remainingH: "Remaining (h)",
    targetDate: "Target date",
    tags: "Tags",
    description: "Description",
    information: "Information",
    viewInDevops: "View in Azure DevOps",
    noSprint: "No sprint",
    created: "Created",
    modified: "Modified",
  },
};

export default en;
